// extracted by mini-css-extract-plugin
export default {"wrap":"dA-z","fullWidth":"eA-z","searchPlacement":"fA-z","items":"gA-z","featureCss":"hA-z","disabled":"iA-z","imgCss":"jA-z"};